<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div class="条件区">
      <app-wmsm-Rtconditions [show]="true" [ShowVendor]="true" [ShowRNO]="true" [ShowPONO]="true" [ShowPANo]="true"
        [ShowBillingStatus]="true" [ShowTime]="true" [QueryFromRT]="onQueryClick()"
        (listenForm)="getFormValue($event)"></app-wmsm-Rtconditions>
    </div>
    <div class="信息区" style="float: right"></div>
    <div class="查询区">
      <!-- <div class="查询条件"  >
        <form nz-form [formGroup]="validateForm">

          <div nz-row>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">{{ "table.PONO" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="16">
                  <input nz-input formControlName="PONO" />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div nz-row>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">{{ "StatementMonth" | translate}}{{ "From" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="16">
                  <nz-date-picker nzMode="month" [nzPlaceHolder]="'selectMonth'| translate" [nzFormat]="monthFormat" formControlName="StatementMonthFrom"></nz-date-picker>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">{{ "StatementMonth" | translate}}{{ "To" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="16">
                  <nz-date-picker nzMode="month" [nzFormat]="monthFormat" [nzPlaceHolder]="'selectMonth'| translate" formControlName="StatementMonthTo"></nz-date-picker>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div nz-row>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">{{ "InvoiceNo" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="16">
                  <input nz-input formControlName="InvoiceNo" />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div nz-row>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">{{ "BillingStatus" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="16">
                  <nz-select formControlName="BillingStatus" nzAllowClear>
                    <nz-option nzLabel="All" nzValue=""></nz-option>
                    <nz-option nzLabel="{{'PaymentApplication'|translate}}" nzValue="0"></nz-option>
                    <nz-option nzLabel="{{'ThePaymentApproved'|translate}}"nzValue="1"></nz-option>
                    <nz-option nzLabel="{{'PaymentToFinance'|translate}}" nzValue="2"></nz-option>
                    <nz-option nzLabel="{{'PaymentToFilled'|translate}}" nzValue="3"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="5"  class="width-100-percent" style="left: 28px">
              <button nz-button class="default-button" nzType="primary" (click)="onSearch()">{{ "Query" | translate}}</button>
            </div>
          </div>
    </form>
      </div> -->
    </div>
    <nz-card>
      <div>
        <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
      </div>
      <div class="表格">
        <nz-table #colSpanTable [nzData]="listOfData"  style="margin-bottom: 10px"
          nzSize="middle" nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]='false'
          [nzPageSize]='pageSize' [nzPageIndex]='pageIndex' [nzScroll]="{ y: '600px',x:'2000px' }">
          <thead>
            <tr>
              <th scope="col" nzWidth="150px" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)">{{ "table.PONO" | translate}}</th>
              <th scope="col" nzWidth="110px">{{ "InvoiceNo" | translate}}</th>
              <th scope="col" nzWidth="110px">{{ "PANo" | translate}}</th>
              <th scope="col" nzWidth="200px">{{ "BillingStatus" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "table.Company" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "table.Buyer" | translate}}</th>
              <!-- <th scope="col" nzWidth="110px">{{ "StatementMonthCN" | translate}}</th> -->
              <th scope="col" nzWidth="150px">{{ "StatementDate" | translate}}</th>
              <th scope="col" nzWidth="200px">{{ "StatementNo" | translate}}</th>
              <th scope="col" nzWidth="110px">{{ "table.Currency" | translate}}</th>
              <th scope="col" nzWidth="110px">{{ "StatementAmount" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "VendorCode" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "VendorName" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "SupplierWindow" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of colSpanTable.data;let i=index">
              <td>{{data.poNo}}</td>
              <td>{{data.invoice}}</td>
              <td>{{data.pano}}</td>
              <td>{{data.withdrawStatus}}</td>
              <td>{{data.company}}</td>
              <td>{{data.wc}}</td>
              <!-- <td>{{data.statementMonth}}</td> -->
              <td>{{data.acDate}}</td>
              <td>{{data.rNo}}</td>
              <td>{{data.currency}}</td>
              <td>{{data.invoice_Amount}}</td>
              <td>{{data.vendor}}</td>
              <td>{{data.vendorName}}</td>
              <td>{{data.vc}}</td>
            </tr>
          </tbody>
        </nz-table>
        <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
          nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize'
          (nzPageSizeChange)="nzPageSizeChange($event)" 
          (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
          <ng-template #renderItemTemplate let-type let-page="page">
         
            <a *ngIf="type === 'page'">{{ page }}</a>
            <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
            <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
          </ng-template>
      </div>
    </nz-card>
  </div>
</nz-spin>